import { useQuery } from '@tanstack/react-query';

export interface Wilayah {
  id: string;
  name: string;
}

const BASE_URL = 'https://www.emsifa.com/api-wilayah-indonesia/api';

export const useProvinces = () => {
  return useQuery<Wilayah[]>({
    queryKey: ['provinces'],
    queryFn: async () => {
      const response = await fetch(`${BASE_URL}/provinces.json`);
      if (!response.ok) throw new Error('Failed to fetch provinces');
      return response.json();
    },
    staleTime: Infinity, // Wilayah data rarely changes
  });
};

export const useRegencies = (provinceId?: string) => {
  return useQuery<Wilayah[]>({
    queryKey: ['regencies', provinceId],
    queryFn: async () => {
      const response = await fetch(`${BASE_URL}/regencies/${provinceId}.json`);
      if (!response.ok) throw new Error('Failed to fetch regencies');
      return response.json();
    },
    enabled: !!provinceId,
    staleTime: Infinity,
  });
};

export const useDistricts = (regencyId?: string) => {
  return useQuery<Wilayah[]>({
    queryKey: ['districts', regencyId],
    queryFn: async () => {
      const response = await fetch(`${BASE_URL}/districts/${regencyId}.json`);
      if (!response.ok) throw new Error('Failed to fetch districts');
      return response.json();
    },
    enabled: !!regencyId,
    staleTime: Infinity,
  });
};
